import { Component, NgModule, enableProdMode, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { DxPopupModule, DxButtonModule, DxTemplateModule, DxDataGridComponent } from 'devextreme-angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import ArrayStore from 'devextreme/data/array_store';
import { BranchchangeService, BranchChange } from '../../services/branchchange.service';
import { Configuration } from '../../../app.constants';
import { formatDate } from '@angular/common';
import { HelperService } from '../../../shared/services/helper.service';
import { DxFormComponent } from 'devextreme-angular';
import { RequestService, Request } from '../../services/request.service';
import { PhotocopyService, ResultQueryInfo } from './../../../revaluation/services/photocopy.service';
import { CetadmissionService, CETadmission } from './../../../studentportal/services/cetadmission.service';
import { NamechangeService, NameChange, Company, GridColumns, columnSetting, GetCourse, FeesProduct, GenderProduct, Documents } from '../../services/namechange.service';
import { ImageUploadService } from './../../../shared/services/image-upload.service';
import { DxPopupComponent } from 'devextreme-angular';
//import { CommondocumentsService, preCommonDocumentsInfo, Documents, UsertDetailsStatus } from 'd:/Projects/StudentPortalUni/src/app/studentportal/services/commondocuments.service'


import {
	DxAccordionModule,
	DxSelectBoxModule,
	DxTextAreaModule,
	DxDateBoxModule,
	DxFormModule
} from 'devextreme-angular';

@Component({
	selector: 'namechangeform',
	templateUrl: './namechangeform.component.html',
	styleUrls: ['./namechangeform.component.scss'],
	providers: [NamechangeService, ImageUploadService]
})

@NgModule({
	imports: [
		BrowserModule,
		DxSelectBoxModule,
		DxTextAreaModule,
		DxDateBoxModule,
		DxFormModule,
		DxAccordionModule
	],
	declarations: [NamechangeformComponent],
	bootstrap: [NamechangeformComponent]
})
export class NamechangeformComponent implements OnInit {
	@ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
	@ViewChild(DxFormComponent) myform: DxFormComponent;
	@Input() index: any;
	columns: GridColumns[];
	dataSourceFees: any;
	academicInstance: any;
	NameChange: NameChange;
	formMode: string;
	private sub: any;
	data: any;
	Feesproducts: FeesProduct[];
	Genderproducts: string[];
	ReDegreeproducts: string[];
	ApplyForImprovementproducts: string[];
	CourseproductsNew: string[];
	CoursePatternproducts: string[];
	Branchproducts: string[];
	companies: Company[];
	payMode: string[];
	nameChangedata: any;
	isdisable = true;
	branchdatasource: any;
	isValid: boolean;
	RequestID: any;
	Fees: number;
	branchdatasource1: any;
	ScheduleList: any;
	courseid: number;
	coursepartid: number;
	branchid: number;
	coursenm: string;
	StudentNameChangeRequestID: number;
	namedisable: boolean = false;
	Savedisabled: boolean = false;
	ResultQueryTypeID: number;
	ResultQueryCode: number = 8;
	resultquerydata: any;
	dataSource: any;
	paymentdis: boolean = true;
	paysource: any;
	paymentmsg: string = "";
	printrecdis: boolean = true;
	PaymentFlag: string;
	Canceldisabled: boolean;
	PaydataSource: any;
	ApplicationNO: number;
	popupVisible: boolean = false;
	namechangeddatasource: any;
	LanguageLabel: any;
	fileUploadErrorMessage: string;
	filesToUpload: Array<File>;
	selectedFileNames: string[] = [];
	public isLoadingData: Boolean = false;
	uploadResult: any;
	res: Array<string>;
	document: any;
	deleteDisabled: boolean = false;
	prefixdata = [
		{ StudentTitle: 'Mr.' },
		{ StudentTitle: 'Mrs.' },
		{ StudentTitle: 'Ms.' },
		{ StudentTitle: 'Mx.' },
	]
	docPath: any;
	path1: string;
	Subjectdata: any;
	obj: any;
	urlDoc: string;
	popupVisible1: boolean;
	popupTitle: string;
	documentId: any;
	showButtons: boolean = true;
	OnLinePaymentConfirmFlag: string;
	ReceiptPrint: any;
	ApplicationReport: any;
	printformdis: boolean = true;
	Oldbirthdate: any;
	popupVisiblePayment: boolean = false;
	DocumentsData: any;
	DocumentID: number;
	dataSourceDoc: any;
	Documents: Documents[];
	//file: File = null;
	file: any;
	ResquestIDdata: any;
	fileName: any;
	DocumentName: any;
	popupVisible3 = false;
	RemoveFileData: any;
	data1: any;
	DocumentDisable: boolean = false;
	uploadDisabled: boolean = false;
	RequsetIDForSave: any;
	applicationNoData: any;
	//DisableSelectionBox: any;

	//errorMessage: string[];
	//CompDocs: Documents[];
	constructor(private router: Router, private RequestService: RequestService,// private CommondocumentsService: CommondocumentsService,
		private route: ActivatedRoute, private helperService: HelperService,
		private BranchchangeService: BranchchangeService, private PhotocopyService: PhotocopyService,
		private NamechangeService: NamechangeService,
		private cetService: CetadmissionService,
		private Configuration: Configuration, private imageService: ImageUploadService,) {
		this.columns = this.BranchchangeService.getGridColumnsFees();
		this.Feesproducts = this.BranchchangeService.getFeesProducts();
		this.Genderproducts = this.BranchchangeService.getGenderProducts();
		this.ReDegreeproducts = this.BranchchangeService.getReDegreeProducts();
		this.ApplyForImprovementproducts = this.BranchchangeService.getApplyForImprovementProducts();
		this.CourseproductsNew = this.BranchchangeService.getCourseProductsNew();
		this.CoursePatternproducts = this.BranchchangeService.getCoursePatternProducts();
		this.companies = BranchchangeService.getCompanies();
		this.data = new ArrayStore({
			data: this.Feesproducts,
			key: "FeesId"
		});
	}
	cancelClick() {
		this.router.navigate(['/changerequest/namechange']);
	}
	PopupShow() {
		this.popupVisible = true;
	}
	PopupClose() {
		this.popupVisible = false;
	}
	showInfo() {
		this.popupVisible1 = true;
	}
	openWindow() {
		this.popupTitle = "View Document";
		this.showInfo();
	}



	ngOnInit() {
		debugger;
		this.LanguageLabel = this.Configuration.LanguageLabel[0];
		this.nameChangedata = [];
		this.sub = this.route.queryParams.subscribe(params => {
			let StudentNameChangeRequestID = params["StudentNameChangeRequestID"];
			this.StudentNameChangeRequestID = StudentNameChangeRequestID;
			this.RequestID = this.StudentNameChangeRequestID;
			this.courseid = params["courseid"];
			this.branchid = params["branchid"];
			this.coursepartid = params["coursepartid"];
			this.coursenm = params["coursenm"];
			this.PaymentFlag = params["PaymentFlag"];
			this.ApplicationNO = params["ApplicationNO"];
		});



		this.docPath = [];
		if (this.ApplicationNO != undefined && this.ApplicationNO != null) {
			debugger;
			this.NamechangeService.GetDocumentPathForNameChange(this.StudentNameChangeRequestID)
				.subscribe((data: NameChange[]) => this.docPath = data,
					error => {
						alert(error);
					},
					() => {
						this.path1 = "";
						if (this.ApplicationNO == 0) {
							this.showButtons = false;
						}
						if (this.docPath.length > 0) {
							if (this.docPath[0].DocumentPath != "" && this.docPath[0].DocumentPath != null && this.docPath[0].DocumentPath != undefined) {
								this.path1 = this.docPath[0].DocumentPath;
							}

						}
						this.Subjectdata = [];
						this.obj = [];
						this.obj.DocumentName = "Document 1";
						this.obj.DocumentPath = this.path1;
						this.obj.DocumentURL = this.obj.DocumentPath.slice(0, -4).slice(50);

						this.obj.ApplicationNO = this.ApplicationNO;
						this.obj.ResultQueryCode = this.ResultQueryCode;
						this.Subjectdata.push(this.obj);


					});
		}
		else {
			this.path1 = "";
			this.Subjectdata = [];
			this.obj = [];
			this.obj.DocumentName = "Document 1";
			this.obj.DocumentPath = this.path1;
			this.obj.DocumentURL = this.obj.DocumentPath.slice(0, -4).slice(50);

			this.obj.ApplicationNO = this.ApplicationNO;
			this.obj.ResultQueryCode = this.ResultQueryCode;

			this.Subjectdata.push(this.obj);


		}
		// --------------------------------------------
		debugger;
		//this.DocumentID = 0;
		this.DocumentsData = [];
		this.NamechangeService.GetDocumentsForNameChange()
			.subscribe((data: Documents[]) => this.DocumentsData = data,
				error => {
					alert(error);
				},
				() => {


					//}); 

					// --------------------------------------------

					this.PhotocopyService.GetResultQueryByCode(this.ResultQueryCode)
						.subscribe((data: ResultQueryInfo[]) => this.resultquerydata = data,
							error => {
								alert(error);
							},
							() => {
								this.ResultQueryTypeID = this.resultquerydata[0].ResultQueryTypeID
								this.BranchchangeService.CheckScheduleForRequest(this.Configuration.ExamInstanceID, this.courseid, this.ResultQueryTypeID)
									.subscribe((data: BranchChange[]) => this.ScheduleList = data,
										error => {
											alert(error);
										},
										() => {
											var Schedule = false;
											if (this.ScheduleList == undefined) {
												Schedule = true;
											}
											if (this.ScheduleList.length == 0) {
												Schedule = true;
											}
											if (this.ScheduleList[0].ScheduleFlag == "N") {
												Schedule = true;
											}
											if (Schedule == true) {
												this.helperService.showWarningMessage("Schedule not defined for this Request");
												this.router.navigate(['/changerequest/namechange']);
												return
											}
											else {
												this.BranchchangeService.GetBranchChangeData(this.Configuration.StudentID, this.courseid)
													.subscribe((data: BranchChange[]) => this.nameChangedata = data,
														error => {
															alert(error);
														},
														() => {
															if (this.nameChangedata.length == 0 || this.nameChangedata == undefined) {
																this.helperService.showWarningMessage("You Can't Request for Name Change");
																this.router.navigate(['/changerequest/namechange']);
															}
															this.nameChangedata = this.nameChangedata[0];
															this.nameChangedata.ApplicationDate = new Date();
															this.nameChangedata.ApplicationFees = this.ScheduleList[0].Fees;
															this.nameChangedata.OldStudentTitle = this.nameChangedata.StudentTitle;
															this.nameChangedata.OldStudentName = this.nameChangedata.StudentName;
															this.nameChangedata.OldStudentFirstName = this.nameChangedata.StudentFirstName;
															this.nameChangedata.OldStudentLastName = this.nameChangedata.StudentLastName;
															this.nameChangedata.OldStudentMiddleName = this.nameChangedata.StudentMiddleName;
															this.nameChangedata.OldStudentMothersName = this.nameChangedata.StudentMothersName;
															this.nameChangedata.OldStudentBirthDate = this.nameChangedata.StudentBirthDateDesc;
															this.Oldbirthdate = this.nameChangedata.StudentBirthDate;
															if (this.StudentNameChangeRequestID != 0) {
																this.NamechangeService.GetChangedNameData(this.Configuration.StudentID, this.coursepartid, this.nameChangedata.BranchID, this.nameChangedata.StudentCollegeID)
																	.subscribe((data: NameChange[]) => this.namechangeddatasource = data[0],
																		error => {
																			alert(error);
																		},
																		() => {
																			this.StudentNameChangeRequestID = this.namechangeddatasource.StudentNameChangeRequestID;
																			if (this.StudentNameChangeRequestID > 0) {
																				this.namedisable = true;
																				this.Savedisabled = true;

																				this.nameChangedata.StudentTitle = this.namechangeddatasource.StudentTitle;
																				this.nameChangedata.StudentName = this.namechangeddatasource.StudentName;
																				this.nameChangedata.StudentFirstName = this.namechangeddatasource.StudentFirstName;
																				this.nameChangedata.StudentLastName = this.namechangeddatasource.StudentLastName;
																				this.nameChangedata.StudentMiddleName = this.namechangeddatasource.StudentMiddleName;
																				this.nameChangedata.StudentMothersName = this.namechangeddatasource.StudentMothersName;
																				this.nameChangedata.StudentBirthDate = this.namechangeddatasource.StudentBirthDateDesc;

																				this.nameChangedata.OldStudentTitle = this.namechangeddatasource.OldStudentTitle;
																				this.nameChangedata.OldStudentName = this.namechangeddatasource.OldStudentName;
																				this.nameChangedata.OldStudentFirstName = this.namechangeddatasource.OldStudentFirstName;
																				this.nameChangedata.OldStudentLastName = this.namechangeddatasource.OldStudentLastName;
																				this.nameChangedata.OldStudentMiddleName = this.namechangeddatasource.OldStudentMiddleName;
																				this.nameChangedata.OldStudentMothersName = this.namechangeddatasource.OldStudentMothersName;
																				this.nameChangedata.OldStudentBirthDate = this.namechangeddatasource.OldStudentBirthDateDesc;
																				this.nameChangedata.DocumentName = this.namechangeddatasource.DocumentPath;

																			}
																			if (this.StudentNameChangeRequestID > 0) {
																				this.namedisable = true;
																				this.Savedisabled = true;
																				this.printformdis = false;
																			}
																			if (this.PaymentFlag == "Y") {
																				this.Canceldisabled = true;
																				this.paymentdis = true;
																				this.printrecdis = false;
																				this.Savedisabled = true;
																			}
																			if (this.OnLinePaymentConfirmFlag == "Y") {
																				this.printrecdis = false;
																			}
																			if (this.PaymentFlag == "N" && this.StudentNameChangeRequestID > 0) {
																				this.Canceldisabled = false;
																				this.paymentdis = false;
																				this.printrecdis = true;
																				this.Savedisabled = true;
																			}
																			if (this.PaymentFlag == "N" && this.StudentNameChangeRequestID == 0) {
																				this.Canceldisabled = true;
																				this.paymentdis = true;
																				this.printrecdis = true;
																				this.Savedisabled = false;
																			}
																		});
															} else {
																if (this.StudentNameChangeRequestID > 0) {
																	this.namedisable = true;
																	this.Savedisabled = true;
																}
																if (this.OnLinePaymentConfirmFlag == "Y") {
																	this.printrecdis = false;
																}
																if (this.PaymentFlag == "Y") {
																	this.Canceldisabled = true;
																	this.paymentdis = true;
																	this.printrecdis = false;
																	this.Savedisabled = true;
																}
																if (this.PaymentFlag == "N" && this.StudentNameChangeRequestID > 0) {
																	this.Canceldisabled = false;
																	this.paymentdis = false;
																	this.printrecdis = true;
																	this.Savedisabled = true;
																}
																if (this.PaymentFlag == "N" && this.StudentNameChangeRequestID == 0) {
																	this.Canceldisabled = true;
																	this.paymentdis = true;
																	this.printrecdis = true;
																	this.Savedisabled = false;
																}
															}

														});
											}
										});
							});

				});
	}



	getDataToDisplay(id) {
		if (id) {
			this.academicInstance = this.BranchchangeService.getSelectedAcademicInstance();
		}
		else {
			this.academicInstance = this.BranchchangeService.getNewAcademicInstance();
		}
	}

	//-----------------------------


	selectionChangedHandlerDocument(e) {

		debugger
		this.DocumentID = e.value
		if (this.DocumentID == undefined || this.DocumentID == null || this.DocumentID == 0) {
			this.helperService.showWarningMessage("Please select document.");
			return false;
		}


		this.NamechangeService.getDocumentByDocumentID(this.DocumentID)
			.subscribe((data: Documents[]) => this.dataSourceDoc = data,

				error => {
					alert(error);
				},
				() => {

					this.DocumentName = this.dataSourceDoc[0].DocumentName


				});
	}

	// getdata(){debugger;
	// 	this.NamechangeService.getDocumentByDocumentID(this.DocumentID)
	// 	  .subscribe((data: Documents[]) => this.dataSourceDoc = data,

	// 		error => {
	// 		  alert(error);
	// 		},
	// 		() => {

	// 		});
	// 		//alert(this.DocumentID);
	// }
	onEditorPreparingDoc(e) {

	}


	uploadFile(event) {
		debugger;

		if (this.DocumentID == undefined || this.DocumentID == null || this.DocumentID == 0) {
			this.helperService.showWarningMessage("Please select document.");
			return false;
		}
		this.file = event.target.files[0];
		this.fileName = this.file.name;
		this.FileUploadsave();
	}

	fileClik() {
		window.open(this.obj.DocumentPath, '_blank');
	}
	onUploadNameChangePdf() {
		debugger;

		this.NamechangeService.uploadNameChangePdf(this.file, this.ResquestIDdata).subscribe(
			data => {
				this.uploadDisabled = true;
				this.helperService.showSuccessMessage("File Uploaded Successfully.");
				//console.log(this.StudentNameChangeRequestID);
			},
			error => {
				debugger;
				//this.popupVisible3 = false;

				this.helperService.showWarningMessage(JSON.stringify(error.error));
				this.uploadDisabled = false;
			},
			() => {

			}
		);

	}


	removeDocument() {
		debugger;
		//this.RemoveFileData =data;
		this.popupVisible3 = true;
	}
	RemoveFileconfirmOK() {
		debugger;
		//this.data1 = this.RemoveFileData;
		if (this.docPath.length > 0) {
			var deleteDocument = {
				"StudentNameChangeRequestID": this.StudentNameChangeRequestID,
				//"UpdatedLoginID": this.data1.UpdatedLoginID,
				"StudentID": this.Configuration.StudentID,
			}

			this.NamechangeService.deleteUploadedPdfDocument(deleteDocument)
				.subscribe((data: NameChange) => {

					this.popupVisible3 = false;
					//this.getdata();
					//this.obj.DocumentPath = "";

					this.obj.DocumentURL = ""
					//this.DocumentName="";
					this.helperService.showSuccessMessage("File Deleted Successfully.");



				},
					error => {
						this.popupVisible3 = false;
						alert(error);
					},
					() => {

					});
		}

	}
	onCloseButton() {
		this.popupVisible3 = false;
	}

	NewRequestID = 0;

	FileUploadsave() {
		debugger;
		if (this.StudentNameChangeRequestID > 0) {

			this.ResquestIDdata = [];
			this.ResquestIDdata.RequestID = this.RequestID;
			this.ResquestIDdata.ExamInstanceID = this.Configuration.ExamInstanceID;
			this.ResquestIDdata.DocumentName = this.DocumentName;
			this.onUploadNameChangePdf();

		} else {
			this.isValid = true;//this.myform.instance.validate().isValid;
			if (this.nameChangedata.OldStudentFirstName == undefined || this.nameChangedata.OldStudentFirstName == null || this.nameChangedata.OldStudentFirstName == "") {
			} else {
				if (this.nameChangedata.StudentFirstName == undefined || this.nameChangedata.StudentFirstName == null || this.nameChangedata.StudentFirstName == "") {
					this.helperService.showWarningMessage("Enter First Name");
					return false;
				}
			}
			if (this.nameChangedata.OldStudentLastName == undefined || this.nameChangedata.OldStudentLastName == null || this.nameChangedata.OldStudentLastName == "") {
			} else {
				if (this.nameChangedata.StudentLastName == undefined || this.nameChangedata.StudentLastName == null || this.nameChangedata.StudentLastName == "") {
					this.helperService.showWarningMessage("Enter Last Name");
					return false;
				}
			}
			if (this.nameChangedata.OldStudentBirthDate == undefined || this.nameChangedata.OldStudentBirthDate == null || this.nameChangedata.OldStudentBirthDate == "") {
			} else {
				if (this.nameChangedata.StudentBirthDate == undefined || this.nameChangedata.StudentBirthDate == null || this.nameChangedata.StudentBirthDate == "") {
					this.helperService.showWarningMessage("Select Date of Birth");
					return false;
				}
			}
			if (this.isValid == true) {

				this.Savedisabled = false;
				this.nameChangedata.CreatedLoginID = this.Configuration.CreatedLoginID;
				this.nameChangedata.UpdatedLoginID = this.Configuration.UpdatedLoginID;
				this.nameChangedata.DeleteFlag = "N";
				this.nameChangedata.ApplicationDate = formatDate(new Date(), 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.StudentBirthDate = formatDate(this.nameChangedata.StudentBirthDate, 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.OldStudentBirthDate = formatDate(this.Oldbirthdate, 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.ExamInstanceID = this.Configuration.ExamInstanceID;
				this.nameChangedata.ExamCentreID = 0;
				this.nameChangedata.AcademicInstanceID = this.Configuration.AcademicInstanceID;
				this.nameChangedata.ResultQueryTypeID = this.ResultQueryTypeID;
				this.nameChangedata.CollegeID = this.nameChangedata.StudentCollegeID;
				this.NamechangeService.save(this.nameChangedata)
					.subscribe(value => {
						debugger;
						//this.onFileUploadSuccessSave();
						this.RequestID = value;


						//-------------------
						this.ResquestIDdata = [];
						//this.obj = [];
						this.ResquestIDdata.RequestID = this.RequestID;
						this.ResquestIDdata.ExamInstanceID = this.Configuration.ExamInstanceID;
						this.ResquestIDdata.DocumentName = this.DocumentName;
						//this.ResquestIDdata.file = this.file;
						//this.ResquestIDdata.push(this.obj);

						this.onUploadNameChangePdf();
						//-------------

						// if (this.nameChangedata.ApplicationFees > 0) {
						// 	this.popupVisiblePayment = true;
						// }
						this.NewRequestID = this.ResquestIDdata.RequestID;

					},
						error => {
							debugger;
							alert(error);
							this.Savedisabled = false;
							// this.errorMessage=this.helperService.getErrorMessage(err);
						},
						() => {

						});
			}
		}

	}


	// getApplicationNO() {
	// 	debugger;

	// 	//this.ResquestIDdata = [];

	// 	//this.RequestID = this.NewRequestID;

	// 	if (this.RequestID > 0) {
	// 		this.NamechangeService.GetApllicationNoByRequestID(this.RequestID)
	// 			.subscribe((data: NameChange[]) => this.applicationNoData = data,


	// 				error => {
	// 					alert(error);
	// 				},
	// 				() => {
	// 					// debugger;
	// 					//this.ApplicationNO = this.applicationNoData.ApplicationNO;
	// 				});
	// 		alert(this.ApplicationNO);
	// 	}
	// }

	//------------------------  




	save() {
		debugger;
		this.RequestID = this.NewRequestID;

		if (this.RequestID > 0) {
			this.onSuccessSave();

		} else {
			this.isValid = true;//this.myform.instance.validate().isValid;
			if (this.nameChangedata.OldStudentFirstName == undefined || this.nameChangedata.OldStudentFirstName == null || this.nameChangedata.OldStudentFirstName == "") {
			} else {
				if (this.nameChangedata.StudentFirstName == undefined || this.nameChangedata.StudentFirstName == null || this.nameChangedata.StudentFirstName == "") {
					this.helperService.showWarningMessage("Enter First Name");
					return false;
				}
			}
			if (this.nameChangedata.OldStudentLastName == undefined || this.nameChangedata.OldStudentLastName == null || this.nameChangedata.OldStudentLastName == "") {
			} else {
				if (this.nameChangedata.StudentLastName == undefined || this.nameChangedata.StudentLastName == null || this.nameChangedata.StudentLastName == "") {
					this.helperService.showWarningMessage("Enter Last Name");
					return false;
				}
			}
			if (this.nameChangedata.OldStudentBirthDate == undefined || this.nameChangedata.OldStudentBirthDate == null || this.nameChangedata.OldStudentBirthDate == "") {
			} else {
				if (this.nameChangedata.StudentBirthDate == undefined || this.nameChangedata.StudentBirthDate == null || this.nameChangedata.StudentBirthDate == "") {
					this.helperService.showWarningMessage("Select Date of Birth");
					return false;
				}
			}
			if (this.isValid == true) {

				this.Savedisabled = true;
				this.nameChangedata.CreatedLoginID = this.Configuration.CreatedLoginID;
				this.nameChangedata.UpdatedLoginID = this.Configuration.UpdatedLoginID;
				this.nameChangedata.DeleteFlag = "N";
				this.nameChangedata.ApplicationDate = formatDate(new Date(), 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.StudentBirthDate = formatDate(this.nameChangedata.StudentBirthDate, 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.OldStudentBirthDate = formatDate(this.Oldbirthdate, 'dd/MMM/yyyy hh:mm:ss', 'en');
				this.nameChangedata.ExamInstanceID = this.Configuration.ExamInstanceID;
				this.nameChangedata.ExamCentreID = 0;
				this.nameChangedata.AcademicInstanceID = this.Configuration.AcademicInstanceID;
				this.nameChangedata.ResultQueryTypeID = this.ResultQueryTypeID;
				this.nameChangedata.CollegeID = this.nameChangedata.StudentCollegeID;
				this.NamechangeService.save(this.nameChangedata)
					.subscribe(value => {
						debugger;
						this.onSuccessSave();
						this.RequestID = value;


						if (this.nameChangedata.ApplicationFees > 0) {
							this.popupVisiblePayment = true;
						}


					},
						err => {
							this.Savedisabled = false;
							//		this.errorMessage=this.helperService.getErrorMessage(err);
						},
						() => {

						});
			}
		}

	}
	onSuccessSave() {
		debugger;

		this.helperService.showSuccessMessage("Name Change Request Saved");


		if (this.nameChangedata.ApplicationFees == 0) {
			this.router.navigate(['/changerequest/namechange']);
			this.Savedisabled = true
		}
	}

	onFileUploadSuccessSave() {
		debugger;

		if (this.nameChangedata.ApplicationFees == 0) {
			this.router.navigate(['/changerequest/namechangeform']);
			this.Savedisabled = false;

		}
	}
	PrintForm() {
		this.NamechangeService.GetNameChangeReport(this.Configuration.StudentID, this.RequestID, this.Configuration.ExamInstanceID)
			.subscribe((data: NameChange[]) => this.ApplicationReport = data,
				error => {
					alert(error);
				},
				() => {
					if (this.ApplicationReport.Message != "" && this.ApplicationReport.IsSuccess != false) {
						window.open(this.ApplicationReport.Message, '_blank');
					}

				});
	}
	CancelApplication() {
		this.NamechangeService.CancelNameChangeApplication(this.RequestID, this.nameChangedata.StudentID, this.Configuration.AcademicInstanceID, this.ResultQueryCode)
			.subscribe((data: NameChange[]) => this.dataSource = data,
				error => {
					alert(error);
				},
				() => {
					this.helperService.showSuccessMessage("Your Application Cancelled sucessfully");
					this.paymentdis = true;

					this.router.navigate(['/changerequest/namechange']);
				});
	}
	GetPaymentTrxNo() {
		;
		this.Canceldisabled = true;
		this.nameChangedata.PurposeCode = this.Configuration.PurposeCodeRequest;
		if (this.nameChangedata.PaymentType == "O") {
			this.nameChangedata.payModeID = 1;
		} else {
			this.nameChangedata.payModeID = 0;
		}

		if (this.nameChangedata.PaymentType == undefined || this.nameChangedata.PaymentType == null) {
			this.nameChangedata.PaymentType = "O";
		}
		this.nameChangedata.ExamInstanceID = this.Configuration.ExamInstanceID;
		if (this.nameChangedata.PaymentType == "O") {
			this.paymentdis = true;
			this.cetService.getPaymentTrxNo(this.nameChangedata.StudentID, this.nameChangedata.CourseID, this.nameChangedata.CoursePartID, this.nameChangedata.BranchID, this.Configuration.AcademicInstanceID, this.Configuration.ExamInstanceID, this.nameChangedata.PurposeCode, this.nameChangedata.ApplicationFees, 0, this.nameChangedata.StudentCollegeID)
				.subscribe((data: CETadmission[]) => this.dataSource = data,
					error => {
						alert(error);
					},
					() => {
						;
						if (this.dataSource[0].merchantTxnNo != undefined || this.dataSource[0].merchantTxnNo != null) {
							this.nameChangedata.customerName = this.dataSource[0].customerName;
							this.nameChangedata.customerEmailId = this.dataSource[0].customerEmailId;
							this.nameChangedata.customerMobileNo = this.dataSource[0].customerMobileNo;
							this.nameChangedata.customerID = this.dataSource[0].OnlinePaymentID;
							this.nameChangedata.merchantTxnNo = this.dataSource[0].merchantTxnNo;
							this.openWindowWithPostRequest();
						}
					});
		}
	}
	openWindowWithPostRequest() {
		;
		var winName = 'MyWindow';
		var winURL = this.Configuration.PaymentAPIURL;
		var windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';

		var params = {
			'StudentID': this.Configuration.StudentID, 'CourseID': this.nameChangedata.CourseID,
			'BranchID': this.nameChangedata.BranchID, 'AcadamicInstanceID': this.Configuration.AcademicInstanceID,
			'PurposeCode': this.nameChangedata.PurposeCode, 'FeesAmount': this.nameChangedata.ApplicationFees,
			'merchantTxnNo': this.nameChangedata.merchantTxnNo, 'customerName': this.nameChangedata.customerName,
			'customerEmailId': this.nameChangedata.customerEmailId, 'customerMobileNo': this.nameChangedata.customerMobileNo,
			'customerID': this.nameChangedata.customerID,
		};
		var form = document.createElement("form");
		form.setAttribute("method", "post");
		form.setAttribute("action", winURL);
		form.setAttribute("target", winName);
		for (var i in params) {
			if (params.hasOwnProperty(i)) {
				var input = document.createElement('input');
				input.type = 'hidden';
				input.name = i;
				input.value = params[i];
				form.appendChild(input);
			}
		}
		document.body.appendChild(form);
		window.open('', winName, windowoption);
		form.target = winName;
		form.submit();
		document.body.removeChild(form);
		this.onSubmit();
	}

	timeLeft: number = 50;
	interval;

	onSubmit() {
		this.paymentmsg = "Your Payment Transaction in Process please wait...";
		this.interval = setInterval(() => {
			if (this.timeLeft > 0) {
				this.timeLeft--;

				this.cetService.GetPaymentTranDetails(this.nameChangedata.merchantTxnNo)
					.subscribe((data: CETadmission[]) => this.paysource = data,
						error => {
							alert(error);
						},
						() => {

							if (this.paysource.length == 0) {
								this.paymentdis = false;

								return;
							}
							if (this.paysource[0].responseCode != undefined || this.paysource[0].responseCode != null) {


								if (this.paysource[0].OnlinePaymentConfirmFlag == "Y") {

									this.NamechangeService.GetUpdatePaymentStatusForNameChange(this.nameChangedata.merchantTxnNo, this.Configuration.ExamInstanceID, this.ApplicationNO, this.Configuration.StudentID)
										.subscribe((data: NameChange[]) => this.PaydataSource = data,
											error => {
												alert(error);
											},
											() => {
												this.nameChangedata.ApplicationFees = this.paysource[0].amount;
												this.paymentdis = true;
												this.helperService.showSuccessMessage("Your Payment Transaction is successful, your Transcation Number is " + this.paysource[0].merchantTxnNo);
												this.printrecdis = false;
											});

								}
								else {
									this.nameChangedata.ApplicationFees = this.paysource[0].amount;
									this.paymentdis = false;
									this.helperService.showWarningMessage("Your Payment Transaction is failure, your Transcation Number is " + this.paysource[0].merchantTxnNo + " try again...");
									this.Canceldisabled = false;
								}
								this.pauseTimer();
							}
							else {
								this.paymentmsg = "Your Payment Transaction in Process...";
							}

						});
			} else {
				this.pauseTimer();
				this.paymentmsg = "Transaction is time out please try again...";
			}
		}, 10000)
	}

	pauseTimer() {
		clearInterval(this.interval);
	}
	PrintReceipt() {
		this.BranchchangeService.GetRequestPaymentReceipt(this.ResultQueryTypeID, this.ApplicationNO, this.Configuration.ExamInstanceID)
			.subscribe((data: BranchChange[]) => this.ReceiptPrint = data,
				error => {
					alert(error);
				},
				() => {
					if (this.ReceiptPrint.Message != "" && this.ReceiptPrint.IsSuccess != false) {
						window.open(this.ReceiptPrint.Message, '_blank');
					}

				});
	}
	viewPdfDocument(data) {
		var path = data.key.DocumentPath;
		window.open(path, "_blank");
	}
	ConfirmOKPayment() {
		this.popupVisiblePayment = false;
		this.BranchchangeService.GetPostInsertReceiptPaymentsForAdmission(this.nameChangedata.StudentID, this.Configuration.AcademicInstanceID, this.nameChangedata.ApplicationFees, this.nameChangedata.CourseID, this.nameChangedata.CoursePartID, this.nameChangedata.BranchID, this.Configuration.ExamInstanceID, this.ResultQueryCode, this.RequestID)
			.subscribe((data: BranchChange[]) => this.ApplicationReport = data,
				error => {
					alert(error);
				},
				() => {
					this.router.navigate(['/changerequest/namechange']);
					this.popupVisiblePayment = false;
				});
	}
	onCloseButtonPayment(e) {
		this.popupVisiblePayment = false;
		this.router.navigate(['/changerequest/namechange']);
	};
}
